import {
  Component,
  Input,
  EventEmitter,
  OnInit,
  Output,
  AfterContentInit,
  AfterViewInit,
  OnDestroy
} from "@angular/core";
import inflect from "inflection";

/**
 * Generated class for the TabberComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "tabber",
  templateUrl: "tabber.html"
})
export class TabberComponent implements AfterViewInit, OnDestroy {
  public _tab: string;
  @Output() protected tabChange: EventEmitter<any> = new EventEmitter();
  public underlineStyle = {};
  @Input() public tabs: any[];

  @Input()
  public set tab(val) {
    this.activate(val);
  }

  public get tab() {
    return this._tab;
  }

  constructor() {
  }

  ngAfterViewInit() {
    this.activate(this.tab);
    window.addEventListener('resize', this.setUnderlineStyles)

  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.setUnderlineStyles)
  }

  activate(tab) {
    this._tab = tab;
    if (tab) {
      this.setUnderlineStyles();
    }

  }

  isActiveTab(tab) {
    return tab == this.tab;
  }

  setUnderlineStyles = () => {
    if (this.tab) {
      const el = document.getElementById(this.getId(this.tab));
      if (el) {
        const width = el.offsetWidth,
          left = el.offsetLeft;
        this.underlineStyle = {
          transform: `translateX(${left}px)`,
          width: `${width}px`
        };
      }
    }
  }

  getId(tab) {
    return `${inflect.dasherize(tab)}-tab-item`;
  }

  handleTabClick(tab) {
    this.tabChange.emit(tab);
  }
}



// WEBPACK FOOTER //
// ./src/components/tabber/tabber.ts